package data.repository

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.database.DataSnapshot
import dev.gitlive.firebase.database.database
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.first
import models.Wish
import kotlin.time.Clock

class FirebaseInvitationRepo {
    private val db = Firebase.database.reference("Invitation")
    private val dbWishes = Firebase.database.reference("WishesAndGift")

    /**
     * Mengecek apakah nama ada di database.
     * @return Invitation jika ditemukan, null jika tidak ada.
     */
    fun checkInvitationByName(name: String): Flow<DataSnapshot> {
        return db.child(name).valueEvents
    }

    /**
     * ucapan yang ada di database.
     * @return Invitation jika ditemukan, null jika tidak ada.
     */
    suspend fun loadMoreWishes(
        pageSize: Int,
        endAt: Long? = null,
    ): Pair<List<Wish>, Long?> {

        val result = mutableListOf<Wish>()
        var cursor = endAt
        var nextCursor: Long? = null
        var hasMore = true

        while (result.size < pageSize && hasMore) {

            var query = dbWishes
                .orderByChild("createdAt")
                .limitToLast(pageSize)

            if (cursor != null) {
                query = query.endAt((cursor - 1).toDouble())
            }

            val snapshot = query.valueEvents.first()
            if (snapshot == null) break

            val rawList = snapshot.children.mapNotNull { child ->

                val isShow = child.child("isShow").value as? Boolean ?: false
                val msg = child.child("wishes").value as? String ?: ""
                val from = child.child("from").value as? String ?: ""

                val createdAt = when (val v = child.child("createdAt").value) {
                    is Long -> v
                    is Double -> v.toLong()
                    else -> return@mapNotNull null
                }

                Wish(
                    name = child.key ?: "",
                    from = from,
                    message = msg,
                    createdAt = createdAt,
                    gift = "0",
                    isShow = isShow
                )
            }.sortedByDescending { it.createdAt }

            if (rawList.isEmpty()) break

            val visible = rawList.filter { it.isShow && it.message.isNotBlank() }

            result.addAll(visible.take(pageSize - result.size))

            val lastRaw = rawList.lastOrNull()?.createdAt

            if (lastRaw == null || lastRaw == cursor) {
                hasMore = false
            } else {
                cursor = lastRaw
                nextCursor = lastRaw
            }
        }

        return result to nextCursor
    }

    /**
     * Update kehadiran
     */
    suspend fun setAttend(name: String, attend: Boolean) {
        db.child(name).child("isAttend").setValue(attend)
    }

    /**
     * Update hadiah
     */
    suspend fun setGift(name: String, gift: String) {
        dbWishes.child(name).child("gifted").setValue(gift)
    }

    /**
     * Update ucapan
     */
    suspend fun setWishes(
        name: String,
        from: String,
        msg: String,
        isShow: Boolean
    ) {
        val safeKey = name
            .replace(".", "_")
            .replace("#", "_")
            .replace("$", "_")
            .replace("[", "_")
            .replace("]", "_")

        val ref = dbWishes.child(safeKey)

        val timestamp = Clock.System.now()
            .toEpochMilliseconds()
            .toDouble()

        ref.child("from").setValue(from)
        ref.child("wishes").setValue(msg)
        ref.child("isShow").setValue(isShow)
        ref.child("createdAt").setValue(timestamp)
    }

    /**
     * Update invitation
     */
    suspend fun addInvitation(
        name: String
    ) {
        val safeKey = name
            .replace(".", "_")
            .replace("#", "_")
            .replace("$", "_")
            .replace("[", "_")
            .replace("]", "_")

        val ref = db.child(safeKey)

        val linkName: String = name.replace(" ", "+")

        val timestamp = Clock.System.now()
            .toEpochMilliseconds()
            .toDouble()

        ref.child("isAttend").setValue(false)
        ref.child("link").setValue("https://wedding.evadanu.com/?to=$linkName")
//        ref.child("wishes").setValue(msg)
//        ref.child("isShow").setValue(isShow)
//        ref.child("createdAt").setValue(timestamp)
    }
}